/**
 * Phase E.3 · Shared "was this product ordered?" helper.
 *
 * Uses the server-projected `effective_ordered_products` when present
 * (backend attaches it on GET /screenings + GET /screenings/{sid}), and
 * falls back to `services[]` for very old cached rows.
 *
 * PM-facing surfaces MUST route every visibility decision through this
 * helper so that:
 *   * un-ordered sections disappear entirely (no "Criminal — Not Ordered"),
 *   * ordered-but-not-yet-run sections stay visible (Pending is not the
 *     same as not-ordered).
 *
 * Never derive visibility from whether results happen to exist.
 */
export function effectiveOrderedProducts(screening) {
  if (!screening) return [];
  const s = screening;
  if (Array.isArray(s.effective_ordered_products)) return s.effective_ordered_products;
  // Fallback path: reconstruct client-side from ordered_products + amendment
  // history (mirrors backend `ordered_products.effective_ordered_products`).
  const base = Array.isArray(s.ordered_products) ? s.ordered_products : (s.services || []);
  const out = [...base];
  for (const evt of s.ordered_products_history || []) {
    if (evt?.action === "amended") {
      for (const svc of (evt.services_added || [])) {
        if (!out.includes(svc)) out.push(svc);
      }
    }
  }
  return out;
}

export function wasProductOrdered(screening, productKey) {
  return effectiveOrderedProducts(screening).includes(productKey);
}

/** Household-scope helper — a product is considered "ordered on this
 *  household" if ANY member screening ordered it. */
export function wasProductOrderedForHousehold(members, productKey) {
  return (members || []).some((m) => wasProductOrdered(m, productKey));
}
